import { cx } from "cva";
import Image from "next/image";
import { BuildHTML } from "~/components/BuildHtml/BuildHtml";
import { HeroWithDemo as HeroWithDemoBlock } from "~/components/LandingPage/schemas";
import { DemoForm } from "~/landing-pages/components/Demo/DemoForm";
import {
  backgroundColorStyle,
  heroDescriptionFontStyle,
  heroHeadlineFontStyle,
  primaryTextColorStyle,
  secondaryTextColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { tagToClassNameMap } from "~/landing-pages/utils/tagToClassNameMap";
import { RequestDemoFormSchema } from "~/lib/shared/schemas/requestDemoSchema";

export type HeroWithDemoProps = Pick<
  HeroWithDemoBlock,
  | "appearance"
  | "description"
  | "openQuestion"
  | "openQuestionCharacterLimit"
  | "salesforceCampaignId"
  | "title"
> & {
  imageUrl: string;
  imageAlt: string;
  onFormSubmit: (values: RequestDemoFormSchema) => void;
};

const appearance = "light";

export const HeroWithDemo: React.FC<HeroWithDemoProps> = ({
  description,
  imageAlt,
  imageUrl,
  openQuestion,
  openQuestionCharacterLimit,
  salesforceCampaignId,
  title,
  onFormSubmit,
}) => (
  <div className={backgroundColorStyle({ appearance })}>
    <div className="grid gap-10 lg:grid-cols-2 lg:grid-rows-[auto_minmax(0,1fr)] lg:gap-y-16">
      <div className="order-1 mx-auto max-w-3xl text-start lg:order-1 lg:col-span-2 lg:text-center">
        <h1
          className={cx(
            heroHeadlineFontStyle(),
            primaryTextColorStyle({ appearance })
          )}
        >
          {title}
        </h1>
        <div
          className={cx(
            heroDescriptionFontStyle(),
            secondaryTextColorStyle({ appearance }),
            "mt-6"
          )}
        >
          <BuildHTML html={description} tagToClassNameMap={tagToClassNameMap} />
        </div>
      </div>

      <div className="relative order-2 min-h-[250px] lg:order-3">
        <Image alt={imageAlt} src={imageUrl} fill className="object-cover" />
      </div>

      <DemoForm
        appearance={appearance}
        ctaText="Submit"
        className="order-3 lg:order-2"
        onFormSubmit={onFormSubmit}
        openQuestion={openQuestion}
        openQuestionCharacterLimit={openQuestionCharacterLimit}
        salesforceCampaignId={salesforceCampaignId}
      />
    </div>
  </div>
);
